import { LineAPI } from '../../../api/datamanager/LineAPI';

export class LinesCommand {
    get(edition, providerId, successCallback, errorCallback) {
        const apiResult = LineAPI.list(edition.network, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as linhas");
            }
        });
    }

    count(edition, providerId, successCallback, errorCallback) {
        const apiResult = LineAPI.countActive(edition.network, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, line, providerId, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(undefined === line.id || 0 === line.id) {
            apiResult = LineAPI.create(edition.network, line);
            successMessage = "Linha criada com sucesso";
        }
        else {
            apiResult = LineAPI.update(edition.network, line.id, line, providerId);
            successMessage = "Linha editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveDurations(edition, durations, successCallback, errorCallback) {
        const apiResult = LineAPI.saveDurations(edition.network, durations);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Durações editadas com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch(_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    takeover(edition, lineId, line, provider, successCallback, errorCallback) {
        const apiResult = LineAPI.takeover(edition.network, lineId, line, provider);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Linha alterada com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, lineId, successCallback, errorCallback) {
        const apiResult = LineAPI.delete(edition.network, lineId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Linha eliminada com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    calculateDurations(edition, lines, successCallback, errorCallback) {
        const dateTicks = (edition.date.getTime() * 10000) + 621355968000000000;
        const apiResult = LineAPI.calculateDurations(edition.network, edition.planning, dateTicks, lines);
        apiResult.then((_) => {
            if(undefined !== successCallback) {
                const output = {
                    message: "Durações calculadas com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if(undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}